/**
 * Formats children to be rendered by snabbdom
 * - recursively flatten + compact arrays
 * - filter out boolean/Symbol values (snabbdom throws on these)
 */

function recurse(arr, result) {
	const {length} = arr;
	for (let i = 0; i < length; i++) {
		const item = arr[i];
		if (Array.isArray(item)) recurse(item, result);
		else if (
			typeof item !== 'boolean' &&
			typeof item !== 'symbol' &&
			item !== null &&
			item !== undefined
		)
			result.push(item);
	}

	return result;
}

export default function formatChildren(arr) {
	return recurse(arr, []);
}
